export default __webpack_public_path__ + "static/img-channel-thumbnail-second-ae26165b6c1dd5f7141a7bcf387f8e09.avif";